"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultConfig = void 0;
class DefaultConfig {
    constructor() {
        /**
         * Organization ID
         *
         */
        this.adobeOrg = "3ADD33055666F1A47F000101@AdobeOrg";
    }
}
exports.DefaultConfig = DefaultConfig;
//# sourceMappingURL=default-config.js.map